import { render } from "./BillsRaised.vue?vue&type=template&id=68b3086c&scoped=true"
import script from "./BillsRaised.vue?vue&type=script&lang=js"
export * from "./BillsRaised.vue?vue&type=script&lang=js"

import "./BillsRaised.vue?vue&type=style&index=0&id=68b3086c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b3086c"]])

export default __exports__